<template>
    <div class="flex-normal" style="display: inline-flex" @click="visible = true">
        <slot name="reference">
            <div v-if="selectName" class="flex-normal">
                <div @click.stop class="text-ellipsis m-r-8" style="max-width: 160px;width: auto">{{ selectName }}</div>
                <el-button type="text">修改</el-button>
            </div>
            <el-button v-else type="primary" :size="size">{{ name }}</el-button>
        </slot>
        <DapSingleSelectDialog @click.native.stop
            v-bind="$attrs"
            @select="handleSelect"
            :visible.sync="visible"
            :selectRow="value"
        ><slot></slot>
            <template #table-header="{column, scope, row, tableData}">
                <slot name="table-header" :column="column" :scope="scope" :row="row" :tableData="tableData"></slot>
            </template>
            <template #table-body="{column, scope, row, tableData}">
                <slot name="table-body" :column="column" :scope="scope" :row="row" :tableData="tableData"></slot>
            </template>
        </DapSingleSelectDialog>
    </div>
</template>

<script>
import DapSingleSelectDialog from './SingleSelectDialog';

export default {
    name: 'DapSingleSelectBtn',
    components: {
        DapSingleSelectDialog,
    },
    props: {
        name: {
            type: String,
            default: '请选择',
        },
        size: {
            type: String,
            default: 'small',
        },
        value: {
            type: Object,
            default: {},
        },
        nameKey: {
            type: String,
            default: 'name',
        }
    },

    data() {
        return {
            visible: false,
        };
    },

    computed: {
        selectName () {
            return this.value[this.nameKey];
        },
    },

    methods: {
        handleSelect (val) {
            this.$emit('select', val);
            this.$emit('input', val);
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
